import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PublicLayout from './layouts/PublicLayout.jsx';
import AdminLayout from './layouts/AdminLayout.jsx';
import LandingPage from './pages/public/LandingPage.jsx';
import AboutPage from './pages/public/AboutPage.jsx';
import NormatividadPage from './pages/public/NormatividadPage.jsx';
import GovernanceBodiesPage from './pages/public/GovernanceBodiesPage.jsx';
import ContactPage from './pages/public/ContactPage.jsx';
import NewsDetailPage from './pages/public/NewsDetailPage.jsx';
import NewsListPage from './pages/public/NewsListPage.jsx';
import CreditosListPage from './pages/public/CreditosListPage.jsx';
import CreditosDetailPage from './pages/public/CreditosDetailPage.jsx';
import CreditosSimuladorPage from './pages/public/CreditosSimuladorPage.jsx';
import SedesVacacionalesPage from './pages/public/SedesVacacionalesPage.jsx';
import SedesVacacionalesDetailPage from './pages/public/SedesVacacionalesDetailPage.jsx';
import ConveniosPage from './pages/public/ConveniosPage.jsx';
import LoginPage from './pages/admin/LoginPage.jsx';
import ForgotPasswordPage from './pages/admin/ForgotPasswordPage.jsx';
import ResetPasswordPage from './pages/admin/ResetPasswordPage.jsx';
import DashboardPage from './pages/admin/DashboardPage.jsx';
import CarruselAdminPage from './pages/admin/CarruselAdminPage.jsx';
import HomeEventosPopupAdminPage from './pages/admin/HomeEventosPopupAdminPage.jsx';
import NoticiasAdminPage from './pages/admin/NoticiasAdminPage.jsx';
import VacacionesAdminPage from './pages/admin/VacacionesAdminPage.jsx';
import CreditosAdminPage from './pages/admin/CreditosAdminPage.jsx';
import NormatividadAdminPage from './pages/admin/NormatividadAdminPage.jsx';
import NormatividadCategoriasAdminPage from './pages/admin/NormatividadCategoriasAdminPage.jsx';
import ContactoAdminPage from './pages/admin/ContactoAdminPage.jsx';
import ConveniosAdminPage from './pages/admin/ConveniosAdminPage.jsx';
import EntesAdminMiembrosAdminPage from './pages/admin/EntesAdminMiembrosAdminPage.jsx';
import UsuariosAdminPage from './pages/admin/UsuariosAdminPage.jsx';
import AuditoriaAdminPage from './pages/admin/AuditoriaAdminPage.jsx';
import ManualUsuarioAdminPage from './pages/admin/ManualUsuarioAdminPage.jsx';
import NotFoundPage from './pages/public/NotFoundPage.jsx';
import ProtectedRoute from './components/auth/ProtectedRoute.jsx';
import ScrollToTop from './components/routing/ScrollToTop.jsx';
import PageSeo from './components/routing/PageSeo.jsx';
import { SeoProvider } from './context/SeoContext.jsx';
import { useAuthStore } from './store/authStore.js';

export default function App() {
  useEffect(() => {
    useAuthStore.getState().bootstrap();
  }, []);

  return (
    <SeoProvider>
      <ScrollToTop />
      <PageSeo />
      <Routes>
      <Route element={<PublicLayout />}>
        <Route index element={<LandingPage />} />
        <Route path="nosotros" element={<AboutPage />} />
        <Route path="entes-administrativos" element={<GovernanceBodiesPage />} />
        <Route path="normatividad" element={<NormatividadPage />} />
        <Route path="contacto" element={<ContactPage />} />
        <Route path="noticias" element={<NewsListPage />} />
        <Route path="noticias/:id" element={<NewsDetailPage />} />
        <Route path="creditos" element={<CreditosListPage />} />
        <Route path="creditos/simulador" element={<CreditosSimuladorPage />} />
        <Route path="creditos/:id" element={<CreditosDetailPage />} />
        <Route path="sedes-vacacionales" element={<SedesVacacionalesPage />} />
        <Route path="sedes-vacacionales/:id" element={<SedesVacacionalesDetailPage />} />
        <Route path="convenios" element={<ConveniosPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>

      <Route path="/admin/login" element={<LoginPage />} />
      <Route path="/admin/olvido-clave" element={<ForgotPasswordPage />} />
      <Route path="/admin/restablecer-clave" element={<ResetPasswordPage />} />

      <Route
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
        <Route path="/admin/dashboard" element={<DashboardPage />} />
        <Route path="/admin/carrusel" element={<CarruselAdminPage />} />
        <Route path="/admin/home-popup" element={<HomeEventosPopupAdminPage />} />
        <Route path="/admin/noticias" element={<NoticiasAdminPage />} />
        <Route path="/admin/vacaciones" element={<VacacionesAdminPage />} />
        <Route path="/admin/creditos" element={<CreditosAdminPage />} />
        <Route path="/admin/normatividad" element={<NormatividadAdminPage />} />
        <Route path="/admin/normatividad/categorias" element={<NormatividadCategoriasAdminPage />} />
        <Route path="/admin/contacto" element={<ContactoAdminPage />} />
        <Route path="/admin/convenios" element={<ConveniosAdminPage />} />
        <Route path="/admin/entes-administrativos" element={<EntesAdminMiembrosAdminPage />} />
        <Route path="/admin/usuarios" element={<UsuariosAdminPage />} />
        <Route path="/admin/auditoria" element={<AuditoriaAdminPage />} />
        <Route path="/admin/manual-usuario" element={<ManualUsuarioAdminPage />} />
        <Route path="/admin/*" element={<NotFoundPage />} />
      </Route>
    </Routes>
    </SeoProvider>
  );
}
